import {css} from 'styled-components'

import theme, {media} from '@/src/config/theme'

export const ContentMainStyles = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  align-items: center;
  justify-content: flex-start;

  &[data-dark='true'] {
    background: ${theme.colors.bgDark};
  }
`

export const ContainerStyles = css`
  .main.static {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  &.container,
  .main.static .static-container {
    width: 100%;

    padding-left: ${theme.token.layout.pagePaddingX};
    padding-right: ${theme.token.layout.pagePaddingX};
    padding-bottom: ${theme.token.layout.pagePadding}px;

    &:not(.no-width-limit) {
      max-width: ${theme.sizes.container}px;
    }

    &.no-padding {
      padding: 0;
    }
    
    & .meta {
      padding-top: 15px;
      padding-bottom: 15px;

      @media ${media.md} {
        padding-top: 20px;
        padding-bottom: 20px;
      }

      h1 + div {
        padding-top: 15px;

        @media ${media.md} {
          padding-top: 20px;
        }
      }
    }
    
    @media ${media.md} {
      padding-bottom: ${theme.token.layout.pagePadding * 2}px;
    }
  }

  main.static .static-menu-container {    
    width: 100%;
    display: flex;

    gap: 20px;

    max-width: ${theme.sizes.container}px;

    padding: ${theme.token.layout.pagePadding}px;

    & .static-container {
      padding: unset;
    }
    
    & .ant-menu-horizontal {
      line-height: normal;
    }

    & .meta {
      padding-top: 15px;
      padding-bottom: 15px;

      @media ${media.md} {
        padding-top: 20px;
        padding-bottom: 20px;
      }

      h1 + div {
        padding-top: 15px;

        @media ${media.md} {
          padding-top: 20px;
        }
      }
    }

    @media (min-width: ${theme.mediaSizes.xl + theme.token.layout.pagePadding}px) {
      padding-left: 0;
      padding-right: 0;
    }

    @media (max-width: ${theme.mediaSizes.md}px) {
      flex-direction: column;
      gap: unset;
    }
  }
`
